import { POWER_KNOWLEDGE } from "./authority.config";

export enum LIST_KNOW {
  EDIT = 0,
  DELETE,
}

export const downListKnow = [
  { text: "编辑", power: POWER_KNOWLEDGE.EDIT, id: LIST_KNOW.EDIT },
  { text: "删除", power: POWER_KNOWLEDGE.DELETE, id: LIST_KNOW.DELETE },
];
